import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { SnackBarService } from '../../@ksm-core/shared/components/snackbar/snack-bar.service';
import { ErrorConstant } from '../../@ksm-core/shared/constants/error.constant';

@Injectable()
export class ClientErrorHandler implements ErrorHandler {

  private static errorShouldNotContains(errorMessage: string, errorShouldNotContains: string[]): boolean {
    for (const error of errorShouldNotContains) {
      if (errorMessage.includes(error)) {
        return false;
      }
    }
    return true;
  }

  constructor(private snackBarService: SnackBarService) {
  }

  public handleError(error: any): void {
    if (!(error instanceof HttpErrorResponse)) {
      if (error.message) {
        if (ClientErrorHandler.errorShouldNotContains(error.message, ErrorConstant.errorShouldNotContains)) {
          this.snackBarService.error(error.message);
        }
      } else {
        if (ClientErrorHandler.errorShouldNotContains(error, ErrorConstant.unknownErrors)) {
          this.snackBarService.error(error);
        }
      }
    } else {
      this.snackBarService.error(error.message);
    }
    if (ClientErrorHandler.errorShouldNotContains(error.message, ErrorConstant.errorShouldNotContainsForConsole)) {
      console.error('error: ', error);
    }
  }
}
